import { ReactNode, useState } from "react";

interface SimpleTooltipProps {
  children: [ReactNode, ReactNode];
}

export const SimpleTooltip: React.FC<SimpleTooltipProps> = ({ children }) => {
  const [isHovered, setHovered] = useState(false);
  const style = {
    //position: "absolute",
    top: "100%",
    left: 0,
    background: "#eee",
    color: "#fff",
    padding: "0.5rem",
    borderRadius: "4px",
    borderWidth: "1px",
    borderStyle: "dotted",
    borderColor: "gray",
    zIndex: 1,
  };

  return (
    <div
      style={{ width: "100%", position: "relative", display: "inline-block" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children[0]}
      {isHovered && <div style={style}>{children[1]}</div>}
    </div>
  );
};
